<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body p-2">

  <!-- Loading -->
  <div *ngIf="loading" class="d-flex justify-content-center py-4">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- No results -->
  <div *ngIf="!loading && externalConsultants.length == 0" class="p-3 text-muted">
    No consultants nearby
  </div>

  <!-- Table -->
  <div *ngIf="!loading && externalConsultants.length > 0" class="table-responsive m-2">
    <table class="table table-hover table-sm mb-0 small">
      <thead>
        <tr>
          <th>Name</th>
          <th>Postcode</th>
          <th>County</th>
          <th>Days/wk</th>
          <th>Days</th>
          <th>Miles Willing to Travel</th>
          <th>Distance To Client</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let consultant of externalConsultants"
          (click)="close(consultant.id, consultant.name)"
          style="cursor: pointer;">
          <td>{{consultant.name}}</td>
          <td>{{consultant.postcode}}</td>
          <td>{{consultant.borough}}</td>
          <td>{{consultant.numberDaysWorkedPerWeek}}</td>
          <td>{{consultant.daysOfTheWeekWorked}}</td>
          <td>{{consultant.milesWillingToTravel}}</td>
          <td>
            {{consultant.distanceToClient}}
            <span>mile</span><span *ngIf="consultant.distanceToClient > 1">s</span>
            <span *ngIf="consultant.distanceToClientDate">
              &nbsp;({{consultant.distanceToClientDate | date:'dd/MM/yyyy'}})
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
